// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mSZL","left":"styles_left__2yqUi"};